import React from "react";
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";

const IMAGE_CONFIGS = {
  profile: {
    aspect: 300 / 300,
    cropSize: { width: 300, height: 300 }
  },
  profileCover: {
    aspect: 1095 / 290,
    cropSize: { width: 1095, height: 290 }
  },
  eventCover: {
    aspect: 5 / 3,
    cropSize: { width: 1095, height: 290 }
  },
  eventPost: {
    aspect: 587 / 400,
    cropSize: { width: 587, height: 400 }
  },
  newsFeed: {
    aspect: 570 / 293,
    cropSize: { width: 570, height: 293 }
  },
  searchCard: {
    aspect: 80 / 80,
    cropSize: { width: 80, height: 80 }
  },
  eventListing: {
    aspect: 916 / 300,
    cropSize: { width: 916, height: 300 }
  }
};

export const ImageUploader = ({
  imageType = "profile",
  onChange,
  children,
  round = false,
  name,
  defaultConfig = false,
  acceptMedia = "image/*"
}) => {
  const config = IMAGE_CONFIGS[imageType] || IMAGE_CONFIGS.profile;

  return (
    <ImgCrop
      showGrid
      quality={1}
      aspect={config.aspect}
      cropShape={round ? "round" : "rect"}
      modalTitle={`Adjust Image (${imageType})`}>
      <Upload
        name={name}
        showUploadList={false}
        action={null}
        listType="text"
        accept={acceptMedia}
        onChange={(info) => {
          if (defaultConfig) {
            onChange(info);
          } else {
            onChange({
              target: {
                name: name,
                files: [info?.file?.originFileObj]
              }
            });
          }
        }}>
        {children}
      </Upload>
    </ImgCrop>
  );
};
